jQuery(document).ready(function ($) {
    const upperDeckComponents = new Swiper('.upper-deck-components__container', {
        loop: true,

        slidesPerView: 1,
        slidesPerGroup: 1,

        centeredSlides: true,

        longSwipes: false,

        spaceBetween: 48,

        grabCursor: true,

        autoplay: true,
        delay: 8000,

        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 5,
                slidesPerGroup: 5,

                grabCursor: false,

                centeredSlides: false,
            }
        }
    });
});